import React, { useEffect, useState } from "react";
import { logout, setSessionTimedOut } from "../actions/usersActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import i18n from "../translations/index";

const useAutoLogout = (startTime) => {
  const [timer, setTimer] = useState(startTime);
  var currentPath;
  if (window.location.href.split("#/").length == 1) {
       currentPath = "login";
  } else {
       currentPath = window.location.href.split("#/")[1].split('/')[0];
  }
 
  useEffect(() => {
    // Whitelist ile belirtilen sayfalarda otomatik çıkış yapmaması için
    const whitelist = [
      "login",
      "pay-by-link",
      "payment",
      "pay-by-constant-link",
      "payment-result",
      "pay-by-link-buffer",
    ];
    if (whitelist.includes(currentPath)) {
      return;
    }

    const myInterval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
    }, 1000);

    const resetTimeout = () => {
      setTimer(startTime);
    };

    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    return () => {
      clearInterval(myInterval);
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
      }
    };
  });

  return timer;
};

function CheckActivity(props) {
  const remainderSeconds = 60;
  const timer = useAutoLogout(600);
  const [modalMessage, setModalMessage] = useState("");

  /**
   * renders modal
   */
  function renderModal() {
    const currentLanguage = i18n.language;
    const showModal =
      timer <= remainderSeconds ? true : false || props.sessionTimedOut;

    const onClosed = () => {
      props.setSessionTimedOut(false);
    };
    return (
      <Modal
        isOpen={showModal}
        modalTransition={{ timeout: 250 }}
        centered={true}
      >
        <ModalHeader>Warning..</ModalHeader>
        <ModalBody>{modalMessage}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onClosed}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  useEffect(() => {
    if (timer === 0) {
      props.logout();
      localStorage.clear();
      window.location.reload(false);
      props.setSessionTimedOut(true);
    } else if (timer <= remainderSeconds) {
      setModalMessage(
        `The system will log out automatically. It will exit after ${timer} seconds.`
      );
    }
  }, [timer]);

  useEffect(() => {
    if (!Boolean(localStorage.getItem("language"))) {
      localStorage.setItem(
        "language",
        "tr"
      );
      i18n.changeLanguage("tr");
    } else {
      i18n.changeLanguage(localStorage.getItem("language"));
    }
    if (props.sessionTimedOut) {
      setModalMessage("The system automatically logged out.");
    }
  }, [props.sessionTimedOut]);

  return <>{renderModal()}</>;
}

const mapStateToProps = (state) => ({
  loggedIn: state.userReducer.loggedIn,
  sessionTimedOut: state.userReducer.sessionTimedOut,
});

const mapDispatchToProps = {
  logout,
  setSessionTimedOut,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CheckActivity
);
